module.exports = __webpack_public_path__ + "img/mo_super07.5bf65d2d.png";